import api from "@/services/api"
import { queryClient } from "@/queryClient"
import { BASE_CATEGORIES_QUERY_KEY } from "../queryKeys"

export const deleteCategory = async (
  categoryId: string
): Promise<unknown> => {
  const response = await api.delete(
    `/products/categories/${categoryId}/`
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })
  return response.body
}
